import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Loader(({ node }, load) => {
  const events = NonNullish(node.dataset.loadEvent, 'on-event').split(' ');

  events.forEach((event) => {
    document.addEventListener(event, load);
  });
});
